/**
 * 侧边栏次要导航组件
 * 
 * 职责：
 * 1. 展示次要功能导航（回收站、设置、帮助等）
 * 2. 处理菜单项的激活状态
 */

import * as React from "react";
import { Link } from "react-router";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shared/ui/sidebar";

import type { SecondaryNavItem, RouteInfo } from "./types";

/**
 * 组件 Props 接口
 */
interface SidebarSecondaryProps extends React.ComponentPropsWithoutRef<typeof SidebarGroup> {
  items: SecondaryNavItem[];
  routeInfo: RouteInfo;
}

/**
 * 侧边栏次要导航组件
 */
function SidebarSecondary({ items, routeInfo, ...props }: SidebarSecondaryProps) {
  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                asChild
                tooltip={item.title}
                isActive={
                  item.url === routeInfo.pathname ||
                  routeInfo.pathname.startsWith(`${item.url}/`)
                }
              >
                <Link to={item.url}>
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}

export default SidebarSecondary;
